import { initialAccessorialRate, type AccessorialRate } from '../../domain/Accessorial'

export function useInitialAccessorialRate({
  accessorialType,
  accessorialRates,
}: {
  accessorialType?: number
  accessorialRates: Array<AccessorialRate>
}) {
  const accessorialRate = accessorialType
    ? accessorialRates.find(rate => rate.type === accessorialType)
    : undefined

  return accessorialRate ?? initialAccessorialRate
}
